import { render, staticRenderFns } from "./TheAddingBatch.vue?vue&type=template&id=9db5f9fa"
import script from "./TheAddingBatch.vue?vue&type=script&lang=ts"
export * from "./TheAddingBatch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports